import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { IUpdateManufactoring } from "mobx-stores/_models/products/manufactoring";
import { string } from "yup";
export const getManufactoringFormSchema =
  (): ObjectSchemaType<IUpdateManufactoring> => ({
    paperOutputStandard: {
      label: "Tiêu chuẩn xuất giấy",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    firstFullPaperSize: {
      label: "Giấy nguyên 1 - Khổ (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    firstFullPaperLength: {
      label: "Giấy nguyên 1 - Dài (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    firstFullPaperPrintQuantity: {
      label: "Giấy nguyên 1 - Số tờ in",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    secondFullPaperSize: {
      label: "Giấy nguyên 2 - Khổ (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    secondFullPaperLength: {
      label: "Giấy nguyên 2 - Dài (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    secondFullPaperPrintQuantity: {
      label: "Giấy nguyên 2 - Số tờ in",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },

    printPaperSize: {
      label: "Giấy in 1 - Khổ(mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    printPaperLength: {
      label: "Giấy in 1 - Dài (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    printPaperSP: {
      label: "Giấy in 1 - SP (pcs)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
    },

    secondPrintPaperSize: {
      label: "Giấy in 2 - Khổ(mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    secondPrintPaperLength: {
      label: "Giấy in 2 - Dài (mm)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    secondPrintPaperSP: {
      label: "Giấy in 2 - SP (pcs)",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
    },
    printStandard: {
      label: "Tiêu chuẩn in",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    frontPrintColor: {
      label: "In mặt trước - Tổng màu in",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
    },
    frontPrintColorCode: {
      label: "In mặt trước - Mã màu in",
      gridSize: 4,
      type: InputType.text,
      validattionYupSchema: string().max(128),
    },
    frontPrintMatte: {
      label: "In mặt trước - Qua láng",
      gridSize: 4,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    frontPrintHandleWay: {
      label: "In mặt trước - Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    frontPrintOtherHandling: {
      label: "In mặt trước - Xử lý khác",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    backPrintColor: {
      label: "In mặt sau - Tổng màu in",
      gridSize: 4,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
    },
    backPrintColorCode: {
      label: "In mặt sau - Mã màu in",
      gridSize: 4,
      type: InputType.text,
      validattionYupSchema: string().max(128),
    },
    backPrintMatte: {
      label: "In mặt sau - Qua láng",
      gridSize: 4,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    backPrintHandleWay: {
      label: "In mặt sau - Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    backPrintOtherHandling: {
      label: "In mặt sau - Xử lý khác",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    printNote: {
      label: "Ghi chú",
      gridSize: 12,
      type: InputType.textArea,
      validattionYupSchema: string().max(1024),
    },
    coatingStandard: {
      label: "Tiêu chuẩn xử lý láng",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    acceptanceStandard: {
      label: "Tiêu chuẩn nghiệm thu",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    otherHandle: {
      label: "Hiệu Ứng - Xử Lý Khác",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    foilProcessingStandard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    foil: {
      label: "Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    foilNote: {
      label: "Ghi chú",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(1024),
    },

    shapeFormingStandard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    shape: {
      label: "Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    shapeNote: {
      label: "Ghi chú",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(1024),
    },
    cutStandard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    cut: {
      label: "Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    cutNote: {
      label: "Ghi chú",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(1024),
    },
    pasteStandard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    paste: {
      label: "Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    pasteNote: {
      label: "Ghi chú",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(1024),
    },
    packageStandard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    package: {
      label: "Cách xử lý",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    packageNote: {
      label: "Ghi chú",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(1024),
    },
    standard: {
      label: "Tiêu chuẩn xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    handleDetail: {
      label: "Chi tiết xử lý",
      gridSize: 12,
      type: InputType.text,
      validattionYupSchema: string().max(256),
    },
    note: {
      label: "Ghi chú",
      gridSize: 12,
      type: InputType.textArea,
      validattionYupSchema: string().max(1024),
    },
  });
